// Combating Graphic
var agingPetsGraphic = document.querySelector('.aging-pets__graphic');


if (agingPetsGraphic) {
  var persons = agingPetsGraphic.querySelectorAll('.aging-pets__person');
  var overlay = agingPetsGraphic.querySelector('.aging-pets__phone-overlay');
  var endCall = agingPetsGraphic.querySelector('.aging-pets__phone-end');
  var bg = agingPetsGraphic.querySelector('.aging-pets__phone-bg');
  var closeButton = agingPetsGraphic.querySelector('.aging-pets__phone-close');
  
  endCall.addEventListener('click', (e)=>{
    overlay.classList.remove('is-active');
    bg.classList.remove('is-active');
    endAllVideos();
  }
  closeButton.addEventListener('click', (e)=>{
    overlay.classList.remove('is-active');
    bg.classList.remove('is-active');
    endAllVideos();
  }


  persons.forEach((person) => {
  	var trigger = person.querySelector('.aging-pets__trigger');

    trigger.addEventListener('click', (e)=>{
      var videoID = person.dataset.video;
      var currentVideo = overlay.querySelector('.aging-pets__video--' + videoID)
      bg.classList.add('is-active');
      overlay.classList.add('is-active');
      currentVideo.classList.add('is-active')
      currentVideo.play()
    });
  });

  function endAllVideos() {
    var allVideos = overlay.querySelectorAll('video')
    allVideos.forEach((item) => {
      item.classList.remove('is-active')
      item.pause()
    }
  }
}


